import { render, staticRenderFns } from "./NewMedia.vue?vue&type=template&id=3cb0c98e&scoped=true&"
import script from "./NewMedia.vue?vue&type=script&lang=js&"
export * from "./NewMedia.vue?vue&type=script&lang=js&"
import style0 from "./NewMedia.vue?vue&type=style&index=0&id=3cb0c98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb0c98e",
  null
  
)

export default component.exports